import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { weatherIconMap } from './WeatherIconMap';
import { WidgetCard } from '../../../components/common';
import { WeatherIconName } from '../../../types/Weather';

export type WeatherUpcomingWeatherCardProps = {
  temperature: string;
  condition: string;
  forecast: { day: string; iconName: WeatherIconName; temp: string }[];
};

export const WeatherUpcomingWeatherCard = ({
  temperature,
  condition,
  forecast,
}: WeatherUpcomingWeatherCardProps) => {
  const { t } = useTranslation();
  const firstIconName = forecast[0]?.iconName;
  const Icon = firstIconName ? weatherIconMap[firstIconName] : null;

  return (
    <WidgetCard
      title={t('weather.upcomingWeather')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack gap="$3.5" justifyContent="space-between" flex={1}>
        <XStack width="100%" justifyContent="space-between" alignItems="center">
          <YStack>
            <Text fontSize="$12" fontWeight="900">
              {temperature}
            </Text>
            <Text fontSize="$9.5">{condition}</Text>
          </YStack>

          {Icon && (
            <YStack justifyContent="center">{Icon(tokens.color.textLight, 119, true)}</YStack>
          )}
        </XStack>

        <XStack
          backgroundColor="$transparentBorder"
          padding="$5"
          borderRadius="$6"
          justifyContent="space-between"
          height="183px">
          {forecast.map(({ day, iconName, temp }, index) => {
            const Icon = weatherIconMap[iconName];
            const isFirst = index === 0;

            return (
              <YStack alignItems="center" key={day} gap="12px">
                <Text fontSize="$9.5" fontWeight={isFirst ? '700' : '400'} color="$textLight">
                  {day}
                </Text>
                {Icon ? Icon(tokens.color.textLight, 36) : null}
                <Text fontSize="$9" fontWeight="700" color="$textLight">
                  {temp}
                </Text>
              </YStack>
            );
          })}
        </XStack>
      </YStack>
    </WidgetCard>
  );
};
